module.exports = __webpack_public_path__ + "static/img/voron.b2b4761.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/voron.png
// module id = qEhZ
// module chunks = 1